export const makeRandomHash = (length) => {
    var result = [];
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
   }
   return result.join('');
}

export const WindowNamespace = function(nsId) {
    if (!nsId) {
        nsId = makeRandomHash(8); // TODO: replace with Symbol
    }
    const set = function(k, v) {
        if (!window[nsId]) { window[nsId] = {}; }
        window[nsId][k] = v;
    }
    const get = function(k, def) {
        if (!window[nsId]) { window[nsId] = {}; }
        return (window[nsId].hasOwnProperty(k)) ? window[nsId][k] : def;
    }
    const keys = function() {
        if (!window[nsId]) { return []; }
        return Object.keys(window[nsId]); //.filter( (k) => window[nsId].hasOwnProperty(k) );
    }
    const id = function() { return nsId; }
    return {
        keys: keys,
        get: get,
        set: set,
        id: id
    };
}

